import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import FarmTableCard from "../../components/Farms/FarmTableCard";
import SearchInput from "../../components/SearchInput";
import { get_all_pairs } from "../../libs/swap_sdk";
import { useAppSelector } from "../../store/hooks";
import { end_loading, start_loading } from "../../store/loading";

const Farms = () => {
  const dispatch = useDispatch();
  const accountAddresses = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );

  const [allPair, setAllPair] = useState<any[]>([]);

  useEffect(() => {
    const fetch = async () => {
      dispatch(start_loading());

      const allPairs = async () => {
        const pairs: any = await get_all_pairs();
        setAllPair(pairs);
        dispatch(end_loading());
      };

      await allPairs();
    };

    if (accountAddresses) {
      fetch();
    } else {
      setAllPair([]);
      dispatch(end_loading());
    }
  }, [accountAddresses, dispatch]);

  return (
    <div className="flex min-h-screen py-16 max-xl:flex-col max-xl:items-center">
      <div className="flex flex-col gap-8 w-full p-10 max-sm:px-4">
        <SearchInput />
        <FarmTableCard pairs={allPair} />
      </div>
    </div>
  );
};

export default Farms;
